import { InfoPageLinkSubtitle } from './InfoPageLinkSubtitle.style';

export default InfoPageLinkSubtitle;
